// AdapterLogo.jsx — Renders brand logo with emoji fallback.
//
// If logo URL is available in adapterLogos.js → <img>; if image fails to
// load → falls back to emoji. CORS-safe via referrerPolicy=no-referrer
// (some CDNs reject requests with referer set).

import { useState } from 'react';
import { getAdapterLogo } from '../../../lib/adapterLogos.js';

export default function AdapterLogo({ adapter, size = 18, className = '' }) {
  const logoUrl = getAdapterLogo(adapter.name);
  const [failed, setFailed] = useState(false);
  const fallbackEmoji = adapter.icon || '🔌';

  if (!logoUrl || failed) {
    return (
      <span
        className={'inline-flex items-center justify-center ' + className}
        style={{ fontSize: size, lineHeight: 1 }}
        aria-hidden="true"
      >
        {fallbackEmoji}
      </span>
    );
  }

  return (
    <span
      className={
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[4px] bg-white/90 ' +
        className
      }
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <img
        src={logoUrl}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        className="h-full w-full object-contain p-[2px]"
        draggable={false}
      />
    </span>
  );
}
